import { toast } from "react-toastify";

const entityTypesMap = {
  Client: "lawyer",
  Ex: "exLawyer",
  Child: "children",
  Party: "parties",
};

const getVariables = ({ entityType, lawyerObject, entityObject }) => {
  if (["Client", "Ex"].includes(entityType)) {
    return {
      [entityTypesMap[entityType]]: {
        delete: { id: { equals: lawyerObject?.id } },
      },
    };
  }

  if (["Child", "Party"].includes(entityType)) {
    return {
      [entityTypesMap[entityType]]: {
        update: {
          where: { id: entityObject.id },
          data: {
            lawyer: {
              delete: {
                id: { equals: lawyerObject?.id },
              },
            },
          },
        },
      },
    };
  }
};

export const useResetLawyerForm = ({
  userId,
  entityType,
  entityObject,
  lawyerObject,
  updateClient,
}) => {
  const handleResetForm = async () => {
    if (!lawyerObject?.id) return;

    const variables = getVariables({ entityType, lawyerObject, entityObject });

    try {
      await updateClient({
        variables: {
          where: {
            id: userId,
          },
          data: variables,
        },
      });

      toast.success("Lawyer information has been successfully reset");
    } catch (error) {
      error?.graphQLErrors?.forEach(({ message }) => toast.error(message));
    }
  };

  return { handleResetForm };
};
